<template>
  <div class="border rounded-md border-slate-200 text-slate-600 overflow-hidden">
    <div class="h-48 sm:h-96 w-full bg-slate-50">
      <DocumentPreview
        :file="resumeFile"
        :url="resumeDataUrl"
      />
    </div>

    <div class="p-4 lg:py-6 flex items-center gap-4 max-w-full">
      <Component :is="resumeMimeImage.component" v-bind="resumeMimeImage.props" class="h-12 py-2"/>
      <div class="flex-1 max-w-44">
        <p class="font-semibold text-sm truncate">{{ fileName || "Resume Uploaded" }}</p>
        <p class="text-xs text-slate-400">{{ formattedFileSize }}</p>
      </div>
      <button type="button" @click="clearResume" tabindex="-1"
              class="ml-auto bg-slate-100 hover:bg-slate-200 rounded-lg h-12 w-12 flex items-center justify-center transition-all"
              :style="colors">
        <ArrowsRightLeftIcon class="h-5 w-5"/>
        <span class="sr-only">Upload a different file</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import ColoredTxtSvg from "./ColoredTxtSvg.vue";
import DocumentPreview from "./DocumentPreview.vue";
import {ArrowsRightLeftIcon} from "@heroicons/vue/24/outline";
import {computed} from "vue";

const emits = defineEmits(["update:resumeFile", "update:resumeDataUrl"]);
const props = defineProps({
  resumeFile: Object,
  resumeDataUrl: String,
  fileName: String,
  formattedFileSize: String,
  primaryBackground: String,
  primaryForeground: String,
});

const clearResume = () => {
  emits("update:resumeFile", null);
  emits("update:resumeDataUrl", null);
};

const resumeMimeImage = computed(() => {
  if (!props.resumeFile) return "";
  switch (props.resumeFile.type) {
  case "application/pdf":
    return {
      component: "img",
      props: {
        src: "https://resources.businessdraft.com/pdf-file-icon.svg",
        alt: "PDF icon",
      }
    };
  case "application/msword":
  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    return {
      component: "img",
      props: {
        src: "https://resources.businessdraft.com/word-icon.svg",
        alt: ".doc and .docx icon",
      }
    };
  default:
    return {
      component: ColoredTxtSvg,
      props: {
        backgroundHex: props.primaryBackground,
        foregroundHex: props.primaryForeground,
      }
    };
  }
});

const colors = computed(() => `color:${props.primaryBackground || "#2c5db6"};`);
</script>
